'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tour = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJoyride = require('react-joyride');

var _reactJoyride2 = _interopRequireDefault(_reactJoyride);

var _localeContext = require('../../core/localeContext');

require('react-joyride/lib/react-joyride-compiled.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var types = ['continuous', 'single'];

var Tour = exports.Tour = (_dec = (0, _localeContext.localeContext)('Tour', {
  back: '后退',
  close: '关闭',
  last: '完成',
  next: '下一个',
  skip: '跳过'
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Tour, _React$Component);

  function Tour(props, context) {
    _classCallCheck(this, Tour);

    var _this = _possibleConstructorReturn(this, (Tour.__proto__ || Object.getPrototypeOf(Tour)).call(this, props));

    _this.handleFocus = function (e) {
      _this.setState({
        selector: e.type === 'tooltip:before' ? e.step.selector : ''
      });
    };

    _this.state = {
      joyrideOverlay: props.mask || true,
      joyrideType: props.type || types[0],
      isRunning: props.visible || false,
      stepIndex: 0,
      steps: [],
      selector: ''
    };
    _this._defaultSteps = [];

    if (Array.isArray(props.steps)) {
      _this.state.steps = props.steps;
    } else {
      if (_this.props.steps.steps) {
        _this._defaultSteps = _this.props.steps.steps;
      }
      context.history.listen(function (location, action) {
        if (action.location) {
          var step = _this.props.steps[action.location.pathname];
          if (step) {
            clearTimeout(_this._timer);
            _this._timer = setTimeout(function () {
              if (step.type) {
                _this._switch(step.type, step.mask);
              } else {
                _this.setState({ joyrideType: types[0] });
              }
              _this.addSteps(step.steps, function () {
                if (step.tip) {
                  _this.addTooltip(step.tip);
                }
              }, step.action);
            }, 300);
          } else {
            if (_this._defaultSteps[0] && document.querySelector(_this._defaultSteps[0].selector)) {
              _this.setState({ steps: _this._defaultSteps });
            }
          }
        }
      });
    }
    return _this;
  }

  _createClass(Tour, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.visible !== false) {
        setTimeout(function () {
          if (!_this2.state.isRunning) {
            _this2.setState({ steps: _this2._defaultSteps, isRunning: true });
          }
        }, 1000);
      }
    }
  }, {
    key: 'addSteps',
    value: function addSteps(steps, callback, action) {
      var newSteps = steps;

      if (!Array.isArray(newSteps)) {
        newSteps = [newSteps];
      }

      if (!newSteps.length) {
        return;
      }
      if (action === 'replace') {
        this.setState({
          isRunning: true,
          steps: newSteps
        }, callback);
      } else if (action === 'push') {
        // Force setState to be synchronous to keep step order.
        this.setState(function (currentState) {
          currentState.steps = currentState.steps.concat(newSteps);
          callback && callback();
          return currentState;
        });
      } else {
        var _steps = void 0;
        var stepIndex = 0;
        if (action) {
          var idx = this._defaultSteps.findIndex(function (item) {
            return item.tag === action;
          });
          if (idx > -1) {
            stepIndex = idx + 1;
            _steps = this._defaultSteps.slice(0, idx + 1).concat(newSteps).concat(this._defaultSteps.slice(idx + 1));
          } else {
            _steps = newSteps.concat(this._defaultSteps);
          }
        } else {
          _steps = this._defaultSteps.concat(newSteps);
        }
        this.setState({
          isRunning: true,
          stepIndex: stepIndex,
          steps: _steps
        }, callback);
      }
    }
  }, {
    key: 'addTooltip',
    value: function addTooltip(data) {
      this._joyride.addTooltip(data);
    }
  }, {
    key: 'next',
    value: function next() {
      this._joyride.next();
    }
  }, {
    key: '_switch',
    value: function _switch(type, mask) {
      var _this3 = this;

      if (type === types[0]) {
        this._joyride && this._joyride.reset();

        this.setState({ isRunning: false, joyrideType: type, joyrideOverlay: mask });
        clearTimeout(this._timer);
        this._timer = setTimeout(function () {
          _this3.setState({ isRunning: true });
        }, 300);
      } else {
        this.setState({ joyrideType: type, joyrideOverlay: mask });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          isRunning = _state.isRunning,
          joyrideOverlay = _state.joyrideOverlay,
          joyrideType = _state.joyrideType,
          selector = _state.selector,
          stepIndex = _state.stepIndex,
          steps = _state.steps;


      return _react2.default.createElement(_reactJoyride2.default, {
        ref: function ref(inst) {
          return _this4._joyride = inst;
        },
        callback: this.handleFocus,
        debug: false,
        disableOverlay: selector === '.j-tour-ticket',
        locale: this.getLocale(),
        run: isRunning,
        showOverlay: joyrideOverlay,
        showSkipButton: true,
        showStepsProgress: true,
        stepIndex: stepIndex,
        steps: steps,
        type: joyrideType });
    }
  }]);

  return Tour;
}(_react2.default.Component), _class2.contextTypes = {
  history: _propTypes2.default.object
}, _class2.propTypes = {
  steps: _propTypes2.default.object,
  type: _propTypes2.default.bool,
  mask: _propTypes2.default.bool,
  visible: _propTypes2.default.bool
}, _temp)) || _class);


//////////////////
// WEBPACK FOOTER
// ./src/components/tour/index.jsx
// module id = 106
// module chunks = 0